const { REACT_APP_ETMC_TOKEN: ETMC_TOKEN } = process.env

export const initPageView = () => {
  const _etmc = window._etmc
  if (!ETMC_TOKEN || !_etmc) return

  _etmc.push(['setOrgId', ETMC_TOKEN])
}

export const trackPageView = () => {
  const _etmc = window._etmc
  if (!ETMC_TOKEN || !_etmc) return

  _etmc.push(['trackPageView', { item: "DIA_Test" }])
}
